<template>
  <div class="curtainParam">
    <!-- 参数 -->
    <Head :name="'窗帘电机'" :add="'/pc/ProCurtain'" :adds="'/pc/ProCurtainParam'" :color="false" />
    <!-- 相关参数 -->
    <div class="paramBox">
      <div class="param">
        <div class="paramTit">相关参数</div>
        <div class="paramImg">
          <img src="../../../assets/product/curtainCtrl.png" alt class="img" />
          <div class="imgName">窗帘电机</div>
        </div>
        <div class="pas">
          <div class="pasLeft">
            <div class="li">
              <div class="pasName">产品型号:</div>
              <div class="pasCont">M300AI</div>
            </div>
            <div class="li">
              <div class="pasName">产品尺寸:</div>
              <div class="pasCont">86×86×13mm</div>
            </div>
            <div class="li">
              <div class="pasName">额定功率:</div>
              <div class="pasCont">5-36</div>
            </div>
            <div class="li">
              <div class="pasName">供电方式:</div>
              <div class="pasCont">直流</div>
            </div>
             <div class="li">
              <div class="pasName">控制接口:</div>
              <div class="pasCont">2×3Pin-D2.5mm金针</div>
            </div>
             <div class="li">
              <div class="pasName">工作频段:</div>
              <div class="pasCont">433.0MHz~453.0MHz</div>
            </div>
          </div>
          <div class="pasRight">
            <div class="li">
              <div class="pasName">工作温度:</div>
              <div class="pasCont">负20°C-65°C</div>
            </div>
            <div class="li">
              <div class="pasName">工作湿度:</div>
              <div class="pasCont">0%-95%RH，无冷凝</div>
            </div>
            <div class="li">
              <div class="pasName">静音指数:</div>
              <div class="pasCont">＜22DB</div>
            </div>
            <div class="li">
              <div class="pasName">驱动方式:</div>
              <div class="pasCont">智能音箱、开关面板、手动操作</div>
            </div>
            <div class="li">
              <div class="pasName">通信协议:</div>
              <div class="pasCont">自定义LSSN2.0</div>
            </div>
            <div class="li">
              <div class="pasName">无线发射功率:</div>
              <div class="pasCont">＜10dBm</div>
            </div>
          </div>
        </div>
        <div class="text">
          <div
            class="tx"
          >窗帘电机是电动窗帘/窗纱的驱动设备，需配合专用轨道使用，可实现对窗帘/窗纱开闭的无线控制。窗帘电机本身还具有手动拉动开闭的功能，以满足用户的不同使用习惯。专用轨道的长度需根据窗帘/窗纱的尺寸定制，可做成直线形、弧形和异形结构，从而适应不同的户型设计。</div>
        </div>
        <div class="star">* 以上所有数据来自BOT实验室，依据测量方式不同,实际结果可能略有差异。</div>
      </div>
    </div>
  </div>
</template>
<script>
import Head from "../../../components/Head.vue";
export default {
  components: {
    Head
  },
  data() {
    return {};
  }
};
</script>
<style lang="less" scoped>
// 相关参数
.paramBox {
  width: 100%;
  background-color: #fff;
  .param {
    width: 12rem;
    margin: 0 auto;
    padding: 1.2rem 0px;
    .paramTit {
      font-size: 0.48rem;
      line-height: 0.48rem;
      font-weight: bold;
      color: #ff9000;
    }
    .paramImg {
      margin-top: 0.65rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      .img {
        width: 4rem;
        height: 2.41rem;
      }
      .imgName {
        margin-top: 0.61rem;
        font-size: 0.36rem;
        line-height: 0.36rem;
        font-weight: 400;
        color: #333333;
      }
    }
    .pas {
      margin-top: 0.81rem;
      display: flex;
      text-align: left;
      justify-content: space-between;
      div {
        display: flex;
        flex-direction: column;
        .li {
          display: flex;
          flex-direction: row;
          margin-bottom: 0.38rem;
          font-size: 0.24rem;
          line-height: 0.24rem;
          font-weight: 400;
          color: #333333;
          &:last-of-type {
            margin-bottom: 0px;
          }
          .pasName {
            margin-right: 1.21rem;
          }
        }
      }
      .pasRight {
        .li {
          &:last-of-type {
            .pasName {
              margin-right: 0.7rem;
            }
          }
        }
      }
    }
    .text {
      margin-top: 0.43rem;
      border-top: 1px solid #333;
      padding-top: 0.4rem;
      text-align: justify;
      font-size: 0.24rem;
      font-weight: 400;
      color: #333333;
      line-height: 0.4rem;
    }
    .star {
      margin-top: 0.8rem;
      text-align: left;
       font-size: 0.1rem;
      line-height: 0.1rem;
      font-weight: 300;
      color: #333333;
    }
  }
}
</style>
